var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload-group" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("label", { staticClass: "filename", attrs: { name: "selectedFiles" } }),
    _vm._v(" "),
    _c("div", { staticClass: "input-btn-group fl" }, [
      _c(
        "div",
        { staticClass: "swb-btn right-radio swb-btn-small swb-btn-primary" },
        [
          _c("input", {
            staticStyle: { width: "100%" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.doUpload()
              }
            }
          }),
          _vm._v(" "),
          _c("i", { staticClass: "icon iconfont icon-shangchuan mr5" }),
          _vm._v(" "),
          _c("span", [_vm._v("上传")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-btn-group fl" }, [
      _c("div", { staticClass: "swb-btn swb-btn-small left-radio" }, [
        _c("input", {
          staticStyle: { width: "100%" },
          attrs: { type: "button", name: "btnSelectFile" }
        }),
        _vm._v(" "),
        _c("i", { staticClass: "icon iconfont icon-wenjianjia mr5" }),
        _vm._v(" "),
        _c("span", [_vm._v("选择")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-141b4cc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-141b4cc8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/FileUpload.vue
// module id = 1622
// module chunks = 1